<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Help</h2>
    </div>
    <div class="flex-area align-center">
      <div class="call-box">
        <div class="help-icon"><i class="fas fa-headset"></i></div>
        <div class="help-text">
          <h2>We are here to help!</h2>
          <a href="tel:2123350233">+1-212-335-0233</a>
        <a style="font-size:23px;" href="mailto:sales@authorizelocal.com"><i class="fas fa-envelope"></i> sales@authorizelocal.com</a>
          <p>Technical Support Hours:
            <br>Monday to Friday <span>10:00 AM - 06:00 PM</span></p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Help',
  metaInfo () {
    return {
      title: 'Help',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Commonly asked questions about Authorize Local'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
